import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { t } from '../../services/i18nService';
import styles from './tableOfContents.scss';
import settingsReader from '../../store/readHelpers/SettingsReader';
import sessionReader from '../../store/readHelpers/SessionReader';
import TOCSection from './TOCSection';
import scrollingService from '../../services/ScrollingService';
import viewReadyTracker from '../../services/ViewReadyTracker';
import { getFilteredListOfQuestions } from '../../services/TOCService';
import uiService from '../../services/UIService';
import tableOfContentsSelector from '../../selectors/tableOfContents/TableOfContentsSelector';

const TableOfContents = (props) => {
    const {
        assessment,
        dispatch,
        flaggedItems,
        isNavigationAllowed,
        questionsFilter,
        response,
        settings,
        onReady,
        ui,
    } = props;

    useEffect(() => {
        // This component can be used as a main view or as a sub component, so we need two ways of handling ready reporting.
        if (onReady) {
            onReady(true);
        } else {
            viewReadyTracker.getReporter()(true);
        }
        scrollingService.scrollToTop();
    }, []);

    const getSections = () => {
        if (!assessment || !assessment.sections || !assessment.sections.length) {
            return null;
        }

        const currentlyShown = getFilteredListOfQuestions(assessment.sections, questionsFilter);

        return currentlyShown.map(({ questions, sectionIndex }) => {
            const section = assessment.sections[sectionIndex];

            return (<TOCSection
                allowNavigation={isNavigationAllowed}
                currentlyShown={questions}
                dispatch={dispatch}
                flaggedItems={flaggedItems}
                key={sectionIndex}
                response={response}
                section={section}
                sectionIndex={sectionIndex}
                settings={settings}
                ui={ui}
            />);
        });
    };

    if (uiService.shouldUseSimplifiedSummaryPage()) {
        return null;
    }

    const settingsBarStyle = settings.settingsBar && settings.settingsBar.active ? { marginTop: '3.5em' } : null;
    const classList = [styles.overview];
    if (settingsReader.hasSettingValue(sessionReader.printParamNames.INSERT_PAGE_BREAK_BEFORE_QUESTION, true)) {
        classList.push('page-break-after');
    }

    return (
        <div className={classList.join(' ')} role="main" style={settingsBarStyle}>
            <h3 className="sr-only">
                { t('testOverview.srOnly.questionListHeader') }
            </h3>

            <table className={styles.body}>
                { getSections() }
            </table>
        </div>
    );
};

TableOfContents.propTypes = {
    assessment: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    flaggedItems: PropTypes.array.isRequired,
    isNavigationAllowed: PropTypes.bool.isRequired,
    onReady: PropTypes.func,
    questionsFilter: PropTypes.string,
    response: PropTypes.object.isRequired,
    settings: PropTypes.object.isRequired,
    ui: PropTypes.object,
};

const mapStateToProps = state => tableOfContentsSelector.selectProps(state);
export default connect(mapStateToProps)(TableOfContents);
